var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 40C0 33.3726 5.37258 28 12 28H68C74.6274 28 80 33.3726 80 40C80 46.6274 74.6274 52 68 52H12C5.37258 52 0 46.6274 0 40ZM12 36C9.79086 36 8 37.7909 8 40C8 42.2091 9.79086 44 12 44H68C70.2091 44 72 42.2091 72 40C72 37.7909 70.2091 36 68 36H12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 40C4 35.5817 7.58172 32 12 32H48C52.4183 32 56 35.5817 56 40C56 44.4183 52.4183 48 48 48H12C7.58172 48 4 44.4183 4 40Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.be4d59c2f49ba6be6e8c79998b278458.svg";
export { ForwardRef as ReactComponent };